var _effectorFileName = "/builds/gmini/front-ui-kit/src/SettingSelectButton/SettingSelectButton.styled.ts";
import styled from 'styled-components';
import { Button } from '../Button/Button.styled';
export const TriangleWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 6px;
  min-width: 6px;
  margin-left: 5px;
`;
export const SettingWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 18px;
  min-width: 18px;
`;
export const SettingSelectButton = styled(Button)`
  height: 32px;
  width: 38px;
  border-radius: 4px;
  background: ${props => props.active ? '#353B60 !important' : 'inherit'};
  opacity: 1;

  & path {
    transition: fill ease-out 0.1s;
    fill: ${props => props.disabled ? 'rgba(53, 59, 96, 0.15)' : props.active ? '#E1E1E9 !important' : '#4c5ecf'};
  }

  &:hover {
    background: ${props => props.disabled ? 'inherit' : 'rgba(53, 59, 96, 0.1)'};
  }

  &:active {
    background: ${props => props.disabled ? 'inherit' : '#353b60'};
  }

  &:active path {
    fill: ${props => props.disabled ? 'rgba(53, 59, 96, 0.15)' : 'rgba(225, 225, 233, 1)'};
  }
`;